import { useEffect, useState } from 'react';

const useWindowSize = (mobileMaxWidth = 767) => {
  const [isMobile, isMobileToggle] = useState();
  const [windowWidth, setWindowWidth] = useState();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const handleScreen = () => {
      isMobileToggle(window.innerWidth <= mobileMaxWidth);
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleScreen);

    handleScreen();

    return () => window.removeEventListener('resize', handleScreen);
  }, []);

  return { isMobile, windowWidth };
};

export default useWindowSize;
